import React from 'react';
import styled from 'styled-components';
import { SMALL_SCREEN } from '../../styles/sizes';

export const DesktopOnly = styled.div`
  @media (max-width: ${SMALL_SCREEN}) {
    display: none;
  }
`;
export const MobileOnly = styled.div`
  @media (min-width: ${SMALL_SCREEN}) {
    display: none;
  }
`;
